import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { CategoryGrid } from './components/CategoryGrid';
import { Newsletter } from './components/Newsletter';
import { AboutSection } from './components/AboutSection';
import { Founder } from './components/Founder';
import { Footer } from './components/Footer';
import { Location } from './components/Location';
import { Lookbook } from './pages/Lookbook';
import { LookbookDetail } from './pages/LookbookDetail';
import { About } from './pages/About';
import { Collection } from './pages/Collection';
import { Booking } from './pages/Booking';
import { NewIn } from './pages/NewIn';
import { HisAndHers } from './pages/HisAndHers';
import { Women } from './pages/Women';
import { Men } from './pages/Men';
import { Kids } from './pages/Kids';
import { Accessories } from './pages/Accessories';
import { Sale } from './pages/Sale';
import { Fabric } from './pages/Fabric';
import { SkinCare } from './pages/SkinCare';
import { GenericCollection } from './pages/GenericCollection';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { ShippingReturns } from './pages/ShippingReturns';
import { Checkout } from './pages/Checkout';
import { Alterations } from './pages/Alterations';
import { ScrollToTop } from './components/ScrollToTop';
import { AnimatePresence, motion } from 'framer-motion';
const pageVariants = {
  initial: {
    opacity: 0,
    y: 10
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -10
  }
};
const PageWrapper = ({
  children
}: {
  children: React.ReactNode;
}) => <motion.div variants={pageVariants} initial="initial" animate="animate" exit="exit" transition={{
  duration: 0.4,
  ease: 'easeOut'
}} data-id="element-0">
    {children}
  </motion.div>;
function Home() {
  return <main className="flex-grow" data-id="element-1">
      <Hero data-id="element-2" />
      <Newsletter data-id="element-3" />
      <AboutSection data-id="element-4" />
      <CategoryGrid data-id="element-5" />
      <Location data-id="element-6" />
    </main>;
}
export function App() {
  const location = useLocation();
  return <div className="min-h-screen flex flex-col selection:bg-black selection:text-white" data-id="element-7">
      <ScrollToTop data-id="element-8" />
      <Header data-id="element-9" />
      <AnimatePresence mode="wait" data-id="element-10">
        <Routes location={location} key={location.pathname} data-id="element-11">
          <Route path="/" element={<PageWrapper data-id="element-13">
                <Home data-id="element-14" />
              </PageWrapper>} data-id="element-12" />
          <Route path="/lookbook" element={<PageWrapper data-id="element-16">
                <Lookbook data-id="element-17" />
              </PageWrapper>} data-id="element-15" />
          <Route path="/lookbook/:id" element={<PageWrapper data-id="element-19">
                <LookbookDetail data-id="element-20" />
              </PageWrapper>} data-id="element-18" />
          <Route path="/alterations" element={<PageWrapper data-id="element-22">
                <Alterations data-id="element-23" />
              </PageWrapper>} data-id="element-21" />
          <Route path="/about" element={<PageWrapper data-id="element-25">
                <About data-id="element-26" />
              </PageWrapper>} data-id="element-24" />
          <Route path="/collection/:category" element={<PageWrapper data-id="element-28">
                <Collection data-id="element-29" />
              </PageWrapper>} data-id="element-27" />
          <Route path="/booking" element={<PageWrapper data-id="element-31">
                <Booking data-id="element-32" />
              </PageWrapper>} data-id="element-30" />

          <Route path="/new-in" element={<PageWrapper data-id="element-34">
                <NewIn data-id="element-35" />
              </PageWrapper>} data-id="element-33" />
          <Route path="/his-&-hers" element={<PageWrapper data-id="element-37">
                <HisAndHers data-id="element-38" />
              </PageWrapper>} data-id="element-36" />
          <Route path="/daddy-&-me" element={<PageWrapper data-id="element-40">
                <GenericCollection title="Daddy & Me" description="Matching heritage for fathers and sons." images={['https://cdn.magicpatterns.com/uploads/24GiQwrwzepMESJJTXz3Q3/image.png', 'https://cdn.magicpatterns.com/uploads/jEej3XExu4hp2w3M59neD7/image.png', 'https://cdn.magicpatterns.com/uploads/bxTL7vVABPe8YuDE1LiVeu/image.png']} data-id="element-41" />
              </PageWrapper>} data-id="element-39" />
          <Route path="/mommy-&-me" element={<PageWrapper data-id="element-43">
                <GenericCollection title="Mommy & Me" description="Coordinated elegance for mothers and daughters." images={['https://cdn.magicpatterns.com/uploads/9ZXEJ3jfY9TKoS3Uy7tuvX/image.png', 'https://cdn.magicpatterns.com/uploads/bMzdmqtiahnnmMbnKaQtb9/image.png', 'https://cdn.magicpatterns.com/uploads/d353YWp21zZqnC3Pek7CAu/image.png']} data-id="element-44" />
              </PageWrapper>} data-id="element-42" />
          <Route path="/women" element={<PageWrapper data-id="element-46">
                <Women data-id="element-47" />
              </PageWrapper>} data-id="element-45" />
          <Route path="/prom-dresses" element={<PageWrapper data-id="element-49">
                <GenericCollection title="Prom Dresses" description="High-fashion evening wear for unforgettable moments." images={['https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=1200', 'https://cdn.magicpatterns.com/uploads/7mhXL4wLM3RtBppQHvnPxN/image.png', 'https://cdn.magicpatterns.com/uploads/vChsCpL21AZ78UvwSRoejp/red_--model.jpg']} data-id="element-50" />
              </PageWrapper>} data-id="element-48" />
          <Route path="/wedding-dresses" element={<PageWrapper data-id="element-52">
                <GenericCollection title="Wedding Dresses" description="Bespoke bridal heritage for your special day." images={['https://images.unsplash.com/photo-1594473030772-ddc15393285c?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1546167108-8395d2df9ac1?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1598554747436-c9293d6a588f?auto=format&fit=crop&q=80&w=1200']} data-id="element-53" />
              </PageWrapper>} data-id="element-51" />
          <Route path="/summer-time-collection" element={<PageWrapper data-id="element-55">
                <GenericCollection title="Summer Time Collection" description="Lightweight textiles and vibrant prints for the season of sun." images={['https://images.unsplash.com/photo-1523381210434-271e8be1f52b?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=80&w=1200', 'https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?auto=format&fit=crop&q=80&w=1200']} data-id="element-56" />
              </PageWrapper>} data-id="element-54" />
          <Route path="/curve-collection" element={<PageWrapper data-id="element-58">
                <GenericCollection title="Curve Collection" description="Empowering silhouettes for every curve." images={['https://cdn.magicpatterns.com/uploads/tVwYkczhEXXsz1orobT2da/image.png', 'https://cdn.magicpatterns.com/uploads/dumL3rwAmxywUmvcQ1HoPe/image.png', 'https://cdn.magicpatterns.com/uploads/9ZXEJ3jfY9TKoS3Uy7tuvX/image.png']} data-id="element-59" />
              </PageWrapper>} data-id="element-57" />
          <Route path="/men" element={<PageWrapper data-id="element-61">
                <Men data-id="element-62" />
              </PageWrapper>} data-id="element-60" />
          <Route path="/kids" element={<PageWrapper data-id="element-64">
                <Kids data-id="element-65" />
              </PageWrapper>} data-id="element-63" />
          <Route path="/unisex" element={<PageWrapper data-id="element-67">
                <GenericCollection title="Unisex" description="Fluid heritage for everyone." images={['https://cdn.magicpatterns.com/uploads/wuY83ouTkEvEoiTmSETLUt/image.png', 'https://cdn.magicpatterns.com/uploads/pJKfmPcBjErq76jQrTYk2j/image.png', 'https://cdn.magicpatterns.com/uploads/tAhHTkZdpHhiBHvZ4nHim3/image.png']} data-id="element-68" />
              </PageWrapper>} data-id="element-66" />
          <Route path="/accessories" element={<PageWrapper data-id="element-70">
                <Accessories data-id="element-71" />
              </PageWrapper>} data-id="element-69" />
          <Route path="/sale" element={<PageWrapper data-id="element-73">
                <Sale data-id="element-74" />
              </PageWrapper>} data-id="element-72" />
          <Route path="/fabric" element={<PageWrapper data-id="element-76">
                <Fabric data-id="element-77" />
              </PageWrapper>} data-id="element-75" />
          <Route path="/coquette-natural-skin-care-collection" element={<PageWrapper data-id="element-79">
                <SkinCare data-id="element-80" />
              </PageWrapper>} data-id="element-78" />
          <Route path="/terms-of-service" element={<PageWrapper data-id="element-82">
                <TermsOfService data-id="element-83" />
              </PageWrapper>} data-id="element-81" />
          <Route path="/privacy-policy" element={<PageWrapper data-id="element-85">
                <PrivacyPolicy data-id="element-86" />
              </PageWrapper>} data-id="element-84" />
          <Route path="/shipping-returns" element={<PageWrapper data-id="element-88">
                <ShippingReturns data-id="element-89" />
              </PageWrapper>} data-id="element-87" />
          <Route path="/checkout" element={<PageWrapper data-id="element-91">
                <Checkout data-id="element-92" />
              </PageWrapper>} data-id="element-90" />
        </Routes>
      </AnimatePresence>
      <Footer data-id="element-93" />
    </div>;
}
export function Root() {
  return <Router data-id="element-94">
      <App data-id="element-95" />
    </Router>;
}